<script lang="ts">
  import { xhr, toast } from "$app/utils"
  import { appStore } from "$app/store.svelte"

  type PlanTypeExt = PlanType & {
    user_count: number
  }

  interface Props {
    plan: PlanType
    status: string
    onupdate: (plan: PlanType) => void
    oncreate: (plan: PlanType) => void
  }

  let { plan, status = "", onupdate, oncreate }: Props = $props()

  let form = $state({})
  let saving = $state(false)

  function savePlan(): void {
    if (status === "edit") {
      updatePlan()
    } else {
      createPlan()
    }
  }

  let errors: any = $state({})

  async function updatePlan(): Promise<void> {
    try {
      saving = true
      const resp = await xhr.patch(`/admin/plans/${plan.id}.json`, {
        plan: form
      })
      toast("Plan updated successfully", "success")
      onupdate(resp.data)
    } catch (e) {
      console.log(e)
      toast("There was an error saving plan", "error")
      errors = e.response.data.errors
    } finally {
      saving = false
    }
  }

  async function createPlan(): Promise<void> {
    try {
      errors = {}
      saving = true
      const resp = await xhr.patch("/admin/plans", {
        plan: form
      })
      toast("Plan updated successfully", "success")
      oncreate(resp.data)
    } catch (e) {
      console.log(e)
      toast("There was an error saving plan", "error")
    } finally {
      saving = false
    }
  }

  function setForm(): void {
    form = {
      name: plan.name,
      company_name: plan.company_name,
      zipcode: plan.zipcode,
      nonprofit: plan.nonprofit,
      marketing_source: plan.marketing_source,
      time_zone: plan.time_zone
    }
  }

  if (status) {
    setForm()
  }
</script>

<h2 class="text-base font-semibold leading-6 text-gray-900">
  {status === "edit" ? "Edit" : "New"} Plan
</h2>

<div class="input-cont">
  <label for="">Plan Name</label>
  <input type="text" bind:value={form.name} class="input" />
  <div class="text-red-500">
    {errors.name || ""}
  </div>
</div>

<div class="input-cont">
  <label for="">Company Name</label>
  <input type="text" class="input" bind:value={form.company_name} />
</div>

<div class="grid grid-cols-2 gap-2">
  <div class="input-cont">
    <label for="">Zipcode</label>
    <input type="text" class="input" bind:value={form.zipcode} />
  </div>
  <div class="pl-4 flex items-end">
    <label for="nonprofit" class="text-lg flex items-center gap-1">
      <input
        class="input-admin input"
        type="checkbox"
        id="nonprofit"
        bind:checked={form.nonprofit}
      />
      Non Profit
    </label>
  </div>
</div>

<div class="input-cont">
  <label for="">Marketing Source</label>
  <input type="text" class="input" bind:value={form.marketing_source} />
</div>

<div class="input-cont">
  <label for="">Time Zone</label>
  <select bind:value={form.time_zone}>
    {#each appStore.time_zones as timeZone}
      <option value={timeZone}>{timeZone}</option>
    {/each}
  </select>
</div>

<div class="p-4 text-center">
  <button class="btn big primary" disabled={saving} onclick={savePlan}>
    {status === "edit" ? "Update" : "Create"}
  </button>
</div>
